import { render } from "./NoticeModal.vue?vue&type=template&id=319bc24b&ts=true"
import script from "./NoticeModal.vue?vue&type=script&lang=ts"
export * from "./NoticeModal.vue?vue&type=script&lang=ts"

import "./NoticeModal.vue?vue&type=style&index=0&id=319bc24b&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/end-vue_us_qa_azure_v24042026_02/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__